import { Material } from '@/colors/materials'
import parts from '../colors/components'
import { ComponentPictureLoader } from './ComponentPictureLoader'

class ColorTileLoader {
  static readonly FRONT_PERSPECTIVE_FOLDER = '20210628_tragwerk.T_Layers_vorne'
  static readonly BACK_PERSPECTIVE_FOLDER = '20210628_tragwerk.T_Layers_hinten'
  static publicPath = process.env.BASE_URL

  static cache: {[key: string]: string} = {}

  static loadColorTile(componentName: string, color: string, material = Material.NONE_MATERIAL) {
    const tileType = this.getTileType(componentName)

    const fileName = `20210628_Farbkachel_${tileType}_${color}${ComponentPictureLoader.getFileSystemSuffixForMaterial(material)}.png`
    if (typeof this.cache[fileName] !== 'undefined') {
      return this.cache[fileName]
    }
    const correctPerspective = this.getCorrectPerspective(componentName)
    const colorTileFolderName = this.getCorrectTileFolderName(componentName)
    const correctedComponentNameForFolderStructure = this.getComponentNameForFolderStructure(componentName)
    const buildUrl = `https://kieserdesign.fra1.digitaloceanspaces.com/img/${correctPerspective.long}/20210628_${correctedComponentNameForFolderStructure}_${correctPerspective.short}/${colorTileFolderName}/${fileName}`
    // eslint-disable-next-line
    // const buildUrl = require(`../assets/watch-components/${correctPerspective.long}/20210628_${correctedComponentNameForFolderStructure}_${correctPerspective.short}/${colorTileFolderName}/${fileName}`) 
    this.cache[fileName] = buildUrl
    return buildUrl
  }

  static getComponentNameForFolderStructure(component: string) {
    if (component === parts.BAND_PART) {
      return 'CorduraBand'
    }
    return component
  }

  /**
   * Some component parts can only be seen from the back(front). Front parts are in a different folder than back parts.
   * This function returns the correct folder for a given component 
   * @param componentName 
   */
  private static getCorrectPerspective(componentName: string) {
    if (parts.isBackPart(componentName)) {
      return {long: this.BACK_PERSPECTIVE_FOLDER, short: 'h'}
    }
    return {long: this.FRONT_PERSPECTIVE_FOLDER, short: 'v'}
  }

  /**
   * The tile folder name depends on the material of the component.
   * @param componentName 
   */
  private static getCorrectTileFolderName(componentName: string): string {
    if (componentName === parts.BAND_PART) {
      return 'Farbkacheln_Cordura_Band'
    }
    if (componentName === parts.NAHT_PART) {
      return 'Farbkacheln_Naht'
    }
    if (componentName === parts.GEHAUESE_PART) {
      return 'Farbkacheln_ExoGehaeuse'
    }
    if (componentName === parts.SEKZEIGER_PART) {
      return 'Farbkacheln_SekZeiger'
    }
    if (componentName === parts.ZIFFERBLATT_PART) {
      return 'Farbkacheln_Zifferblatt'
    }
    if (componentName === parts.SEKRING_PART) {
      return 'Farbkacheln_SekRing'
    }
    if (componentName === parts.SCHRAUBEN_PART) {
      return 'Farbkacheln_Schrauben'
    }
    if (componentName === parts.ROTORWABEN_PART) {
      return 'Farbkacheln_RotorWaben'
    }
    if (componentName === parts.WERKHALTERRING_PART) {
      return 'Farbkacheln_Werkhaltering'
    }
    if (componentName === parts.KRONE_PART) {
      return 'Farbkacheln_Krone'
    }
    return 'Farbkacheln_Titan_anodisiert'
  }

  /**
   * The file names of the single color tiles also depend on the material of the component
   * @param componentName
   */
  private static getTileType(componentName: string) {
    if (componentName === parts.BAND_PART) {
      return 'Band'
    }
    if (componentName === parts.GEHAUESE_PART) {
      return 'Gehaeuse'
    }
    if (componentName === parts.NAHT_PART) {
      return 'Naht'
    }
    if (componentName === parts.SEKZEIGER_PART) {
      return 'SekZeiger'
    }
    if (componentName === parts.ZIFFERBLATT_PART) {
      return 'Zifferblatt'
    }
    if (componentName === parts.ROTORWABEN_PART) {
      return 'RotorWaben'
    }
    if (componentName === parts.SCHRAUBEN_PART) {
      return 'Schrauben'
    }
    if (componentName === parts.WERKHALTERRING_PART) {
      return 'Werkhaltering'
    }
    if (componentName === parts.SEKRING_PART) {
      return 'SekRing'
    }
    if (componentName === parts.KRONE_PART) {
      return 'Krone'
    }
    return 'Metall'
  }
}

export {ColorTileLoader}